// this style is in right a panel, out of the feature scope, so use as the global pattern
import { uetTagSelectorStyles } from './uet-tag-selector-style';
import { underlineLinkStyle, statusStyle, paginationStyle, entitySelectorStyle } from './shared-styles-from-theme-fluent';
import { audienceAssociationSectionStyle } from './audience-association-section-style';

export const audienceModalStyles = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }, { modalWidth = 800 } = {}) => ({
  '.audience-modal': {
    left: 'auto',
    background: '#FFFFFF',
    display: 'block',
    opacity: 1,
    position: 'relative',
    overflow: 'unset !important',

    ...underlineLinkStyle({ palette, elementLocator: 'a.HelpTopic' }),

    '& div.error': {
      float: 'right',
      width: '100%',
      color: '#A80000',
      fontSize: 14,
    },

    '& input.error': {
      borderColor: '#A80000',
    },

    '& .modal-dialog': {
      width: '100%',
      transform: 'none !important',
      transition: 'none !important',
      display: 'block',
      overflow: 'unset',
      maxWidth: 'none',
      height: 'auto',

      '& .modal-content': {
        boxShadow: 'none',

        '& .modal-header': {
          display: 'none',
        },

        '& .modal-body': {
          padding: 0,

          '& .row': {
            margin: 0,

            '& p': {
              fontSize: 14,
              marginBottom: 10,
              padding: 0,
            },

            '& .col-sm-7, .col-sm-12': {
              padding: 0,
            },

            '& .inline-sm-input': {
              width: 64,
              margin: '0 10px',
            },
          },

          '& .membershipDuration': {
            width: 64,
          },

          '& .step2': {
            marginTop: 15,

            '& .row:nth-child(3)': {
              marginBottom: 0,
            },

            '& .col-sm-12': {
              padding: 0,
            },

          },

          '& .product-audience-popup': {

            '& .step2': {
              width: 1200,
            },
          },

          '& .text-highlighted': {
            color: '#D90026',
          },

          '& textarea': {
            resize: 'none',
          },

          '& .form-horizontal': {
            '& .control-label': {
              float: 'none',
              width: '100%',
              textAlign: 'left',
            },
          },
        },

        '& .modal-footer': {
          padding: '16px 0px 0px 0px',
          textAlign: 'left',
          borderTop: '1px solid #eee',

          '& .btn': {
            lineHeight: '32px',
            marginLeft: 0,
            marginRight: 12,
          },
        },
      },
    },
  },

  '.annotation-text': {
    textAlign: 'right',
    fontSize: 14,
    color: palette.neutralPrimary,
    lineHeight: '24px',
  },

  '.audienceConditionControl': {
    '& .panel-form': {
      border: `1px solid ${palette.neutralSecondary}`,
      borderRadius: 2,
      padding: '5px 10px',

      '& .simpleMode': {
        padding: 0,
        overflow: 'unset',

        '& .audiencePickerContainer': {
          paddingBottom: 21,

          '& h5': {
            fontSize: 14,
            fontWeight: 400,
          },

          '& .exampleText': {
            fontSize: 12,
          },
        },

        '& .audiencePickerControl': {

          '& .audiencePicker': {
            height: 'auto',
            width: '100%',

            '& option': {
              fontWeight: 400,
              display: 'block',
              whiteSpace: 'pre',
              minHeight: '1.2em',
              padding: '0px 2px 1px',
            },
          },

          '& .create': {
            position: 'relative',
            right: 10,
            top: -22,
            fontSize: 14,
            color: '#0078d4',
            fontWeight: 400,
            opacity: 1,
          },
        },
      },

      '& .panel-footer': {
        background: palette.white,
        padding: 0,
      },
    },
  },

  ...uetTagSelectorStyles({ palette, iconFontFamily }, { width: modalWidth }),

  '.uet-tag-help-panel': {

    width: modalWidth,

    '& .product-audience-code-sample': {
      border: `1px solid ${palette.neutralSecondary}`,
      padding: 15,
      wordBreak: 'break-all',
      '& p': {
        margin: 0,
        padding: 0,
      },
    },

    '& .pull-right': {
      padding: 0,
      marginTop: 15,
      width: 'fit-content',
      textAlign: 'right',
      display: 'flex',
      flexDirection: 'row',

      '& button': {
        width: 'auto',
        display: 'inline-block',
        position: 'relative',
      },

      '& .btn-uet-download-tag, & .btn-uet-email-tag': {
        marginLeft: 15,
      },
    },
  },

  '.manageRemarketingListContainer': {
    '& > div:nth-child(6) > form > div:nth-child(4)': {
      '& > .col-sm-2': {
        width: 0,
        padding: 0,
      },
      '& > .col-sm-10': {
        width: modalWidth,
      },
    },

    ...statusStyle({ palette }),
    ...paginationStyle({ palette }),
    ...entitySelectorStyle({ palette }),
    ...audienceAssociationSectionStyle({ palette }),

    '& div.error': {
      color: palette.redDark,
    },

    '& .inactive': {
      color: palette.neutralTertiary,
    },

    '& .panel-title hr': {
      marginTop: 10,
      marginBottom: 20,
    },

    '& .audience-type-selector-panel .audience-type-selector label .type-normal': {
      marginLeft: '8px',
    },

    '& >div[data-bind="visible: isAudienceTitleStep() || editMode()"]': {
      width: 528,
      '& .col-sm-10': {
        width: '100%',
      },

      '& #ManageLblName + .col-sm-6': {
        width: '100%',
      },
    },

    '& >div[data-bind="visible: isAudienceDetailStep() || (!isCustomerListAudience() && editMode())"], & >div:nth-child(6)': {
      '& #ManageLblSelectTag + .col-sm-10, & #ManageLblListOption + .col-sm-10': {
        width: '100%',
      },

      '& input[data-bind="checked: isInfiniteDuration"] + .col-sm-1': {
        width: 64,
        boxSizing: 'content-box',
      },
    },

    '& > div.panel-group': {
      '& > form.formContainer.form-horizontal': {
        '& .form-group': {
          marginBottom: 5,
        },
        '& label.control-label.col-sm-2': {
          textAlign: 'left',
        },
        '& #ManageLblListOption': {
          width: '100%',
        },
      },
    },

    '& #tagsDropDown': {
      marginLeft: -15,
      width: modalWidth,
      '& + .error': {
        marginLeft: -15, // same margin as #tagsDropDown
        float: 'unset',
      },
    },

    '& #conjunctionDropDown_EventCategory, #conjunctionDropDown_EventAction, #conjunctionDropDown_EventLabel, #conjunctionDropDown_EventValue': {
      width: '100%',
    },

    '& #remarketingDescription': {
      width: modalWidth,
      resize: 'none',
    },

    '& #remarketingDescription + .annotation-text': {
      width: modalWidth,
      textAlign: 'right',
    },

    '& .remarketing-list-panel #whoToAddDropDown': {
      width: modalWidth,
    },

    '& .panel-title': {
      '& h3': {
        fontSize: 16,
        margin: 0,
      },

      '& .indented-section': {
        marginLeft: 8,
      },
    },

    '& .title-area': {
      '& h3': {
        fontSize: 14,
        fontWeight: 400,
      },
    },

    '& .h5': {
      fontSize: 14,
    },

    '& .control-label': {
      '& label': {
        display: 'inline-block',
      },
    },

    '& .policyContainer': {
      '& h5': {
        fontWeight: 400,
        fontSize: 14,
      },
    },

    '& input.membershipDuration': {
      width: 50,
    },

    '& .membership-duration>div.col-sm-1': {
      width: 80,
    },

    '& .radio label div': {
      float: 'none',
      display: 'inline-block',
    },

    '& .customer-list-detail-panel': {
      '& >label.control-label': {
        textAlign: 'left !important',
      },

      '& >div.col-sm-8': {
        width: modalWidth,
        marginLeft: '15px !important',

        '& .customer-list-upload-selector': {
          '& .radio': {
            clear: 'both',

            '& label': {
              display: 'flow-root',
            },

            '& input[type="radio"]': {
              float: 'left',
              marginRight: 0,
              top: 0,
            },

            '& input[type="radio"] + div': {
              float: 'left',
              marginLeft: 8,
            },

            '& .customer-list-file-picker': {
              '& .row': {
                marginBottom: 5,
                marginLeft: 0,

                '& .file-path-indicator': {
                  height: '32px !important',
                  width: '270px !important',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
              },
            },
          },
        },
        '& .upload-selector-error': {
          float: 'left',
          marginLeft: 28,
          marginBottom: 20,
        },
        '& .consent-line': {
          marginLeft: 8,
          '& .checkbox-inline': {
            paddingLeft: 28,
            '& input': {
              marginLeft: -28,
            },
          },
          '& .consent-line-error': {
            marginLeft: 28,
            marginBottom: 20,
          },
        },
      },
    },

    '& .form-group': {
      '& .col-sm-10': {
        '& .radio': {
          '& >input[data-bind="checked: isInfiniteDuration"]': {
            float: 'left',
            marginLeft: 0,
          },

          '& .col-sm-1': {
            paddingLeft: 0,
          },

          '& .col-sm-1.form-control-static': {
            width: 'auto',
          },

          '& .col-sm-1 > label': {
            padding: '0 0 0 8px',
          },
        },
      },
    },

    '& .shared-library-audience-scope-editor': {
      width: modalWidth,

      '& .sharing-scope-dblist': {
        padding: 0,
        marginTop: 10,

        '& .alert.alert-info': {
          width: '100%',
          padding: 10,
          marginBottom: 10,
        },

        '& > .form-horizontal.row': {
          margin: 0,
          width: modalWidth,
          '& .form-group.row': {
            marginLeft: 0,
            marginRight: 0,
          },
        },

        '& .col-lg-6': {
          paddingRight: 0,

          '& .col-lg-12': {
            padding: 0,

            '& .panel-form': {
              border: '1px solid #BBB',
              padding: 1,
              height: '400px',

              '& .panel-heading': {
                backgroundColor: `${palette.white} !important`,
                padding: '0 8px',
                marginTop: '48px',
                height: 36,

                '& .panel-title': {
                  marginTop: 0,
                  fontSize: 16,
                  lineHeight: '30px',
                },
              },

              '& .panel-body': {
                padding: 0,
                position: 'unset',

                '& .sharing-scope-tree-view': {
                  '& .sharing-scope-tree-view__search-box': {
                    position: 'absolute',
                    top: 0,
                    width: '100%',
                    left: 0,
                    height: '48px',

                    '& .search-box__input-group': {
                      position: 'relative',

                      '& .search-box__input': {
                        height: 48,
                        paddingLeft: 48,
                      },

                      '& .search-box__icon': {
                        fontFamily: iconFontFamily,
                        fontSize: 16,
                        color: palette.themePrimary,
                        position: 'absolute',
                        padding: 12,
                        top: 0,
                      },

                      '& .search-box__icon:before': {
                        content: '"\\E721"',
                      },
                    },
                  },

                  '& .sharing-scope-tree-view__add-all, .sharing-scope-tree-view__remove-all': {
                    textAlign: 'right',
                    paddingRight: 8,
                    color: palette.themePrimary,

                    '& .arrow-button': {
                      verticalAlign: 'middle',
                    },

                    '& .arrow-button.enabled': {
                      paddingLeft: 5,
                    },

                    '& .arrow-button.remove': {
                      paddingRight: 5,
                    },
                  },

                  '& .sharing-scope-tree-view__hierarchy-tree': {
                    paddingLeft: 8,

                    '& .glyphicon-triangle-bottom': {
                      fontFamily: iconFontFamily,
                      fontSize: 12,
                    },

                    '& .glyphicon-triangle-bottom:before': {
                      content: '"\\E70D"',
                    },

                    '& .glyphicon-triangle-right': {
                      fontFamily: iconFontFamily,
                      fontSize: 12,
                    },

                    '& .glyphicon-triangle-right:before': {
                      content: '"\\E76C"',
                    },

                    '& .hierarchy-tree': {
                      height: '290px',

                      '& .glyphicon': {
                        paddingRight: 5,
                      },

                      '& .ReactVirtualized__Grid': {
                        overflow: 'scroll !important',

                        '& .ReactVirtualized__Grid__innerScrollContainer': {
                          overflow: 'visible !important',

                          '& .tree-node': {
                            whiteSpace: 'nowrap',
                          },
                        },
                      },
                    },

                    '& ::-webkit-scrollbar':
                    {
                      width: 4,
                      backgroundColor: 'transparent',
                    },

                    '& ::-webkit-scrollbar-track':
                    {
                      backgroundColor: 'transparent',
                    },

                    '& ::-webkit-scrollbar-thumb':
                    {
                      width: 4,
                      height: 44,
                      backgroundColor: '#EBEAE8',
                    },

                    '& ::-webkit-scrollbar:horizontal':
                    {
                      height: 4,
                      backgroundColor: 'transparent',
                    },

                    '& ::-webkit-scrollbar-track:horizontal':
                    {
                      backgroundColor: 'transparent',
                    },

                    '& ::-webkit-scrollbar-thumb:horizontal':
                    {
                      width: 200,
                      height: 4,
                      backgroundColor: '#EBEAE8',
                    },
                  },
                },
              },
            },
          },
        },

        '& .col-lg-6:first-child': {
          paddingLeft: 0,
          paddingRight: 15,
        },

        '& .col-lg-6:last-child': {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },

      '& .sharing-scope-dblist .col-lg-6:nth-child(2)': {
        '& .panel-heading': {
          marginTop: '0 !important',
        },

        '& .hierarchy-tree': {
          height: '338px !important',
        },
      },
    },

    '& .upload-panel': {
      '& .panel-title + .form-group': {
        margin: 0,
      },
      '& .result-panel-content': {
        margin: '0 !important',
        '& .result-table': {
          width: 300,
          '& thead, & tbody': {
            background: palette.white,
            borderLeft: 0,
            borderRight: 0,
            '& td:first-child': {
              borderLeft: 0,
            },
            '& td:last-child': {
              borderRight: 0,
            },
          },
          '& td': {
            padding: 12,
            width: '50%',
          },
        },

        '& .result-panel-progress': {
          '& .progress-status': {
            color: '#323130',
            marginBottom: 5,
            fontWeight: 600,
          },
          '& .progress-container': {
            '& .progress-bar': {
              backgroundColor: palette.themePrimary,
            },
          },
        },

        '& .result-panel-success-statement': {
          '& ul': {
            padding: 0,
            margin: '12px 0',
            '& li': {
              marginLeft: 20,
            },
          },
        },
      },
    },

    '& .buttonsContainer .btn': {
      marginRight: 12,
    },
  },

  '.conditionsPanel': {
    '& .col-sm-3': {
      paddingRight: 0,
    },

    '& .filtercloseimage': {
      fontFamily: iconFontFamily,
      color: palette.neutralSecondary,
      cursor: 'pointer',
      right: -8,
      top: 5,
      position: 'relative',
    },
    '& .filtercloseimage:before': {
      content: '"\\E711"',
    },
  },

  '.product-audience-creation': {
    '& .row-gap': {
      '& input[type="number"]': {
        '-moz-appearance': 'textfield',
      },

      '& input[type="number"]::-webkit-outer-spin-button, input[type="number"]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none !important',
        margin: 0,
      },

      '& .form-inline': {
        paddingLeft: 28,
      },
    },
  },

  '.uet-modal': {
    zIndex: 1000,

    '& .modal-dialog': {
      maxWidth: 550,
      padding: 0,

      '& .modal-content': {

        '& .modal-body': {
          paddingBottom: 26,

          '& .error': {
            color: '#A80000',
          },

          '& .footerDoneCancel': {
            '& .save-btn-cb': {
              marginRight: 8,
            },
          },
        },
      },
    },

    '& .condition-dialog': {
      float: 'right',
      right: 162,
    },
  },

  '.k-list-container': {
    background: palette.white,
    border: '1px solid #E5E5E5',

    '& .k-list': {
      listStyle: 'none',
      padding: 0,
    },

    '& .k-item': {
      padding: 5,
    },

    '& .k-item:hover, .k-state-focused': {
      background: '#E5E5E5',
    },

    '& .k-extra': {
      borderTop: '1px solid #E5E5E5',
    },
  },

  '.audience-creation-panel': {
    '& .panel-body': {
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
      '& >div': {
        flex: 1,
        '& .audience-modal': {
          height: '100%',
          '& .modal-dialog': {
            height: '100%',
            '& .modal-content': {
              height: '100%',
              display: 'flex',
              flexDirection: 'column',

              '& .modal-body': {
                flex: 1,
                width: modalWidth,
                '& .impression-based-list-panel': {
                  '& .col-sm-12 ': {
                    padding: 15,
                  },
                  '& #level-selector': {
                    marginLeft: '15px',
                    border: `1px solid ${palette.neutralSecondary}`,
                    height: '32px',
                    paddingTop: '5px',
                    marginTop: '3px',
                    width: 160,
                    '& .caret': {
                      position: 'absolute',
                      right: '5px',
                      marginTop: '3px',
                    },
                    '& ul.dropdown-menu>li': {
                      paddingLeft: '10px',
                    },
                    '& ul.dropdown-menu>li:hover': {
                      backgroundColor: palette.neutralLighter, // '#f3f2f1',
                    },
                  },
                  '& .campaign-level-selection': {
                    paddingTop: '3px',
                    '& .campaign-text': {
                      paddingTop: '5px',
                      display: 'block',
                    },
                  },
                  '& .adgroup-level-selection': {
                    paddingTop: '3px',
                    '& span.adgroup-label': {
                      marginRight: '40px',
                      minWidth: 60,
                      whiteSpace: 'nowrap',
                    },
                  },
                },
                '& .cnf-or-dnf-panel': {
                  '& >.form-group': {
                    marginLeft: '0px !important',
                    '& select': {
                      marginLeft: '0px !important',
                    },
                  },
                  '& .condition-title': {
                    marginLeft: '15px !important',
                    paddingTop: '7px !important',
                    paddingBottom: '5px !important',
                  },
                },
              },
            },
          },
        },
      },
    },
  },

  '.manage-tag-alert-panel': {
    '& .panel-content': {
      width: 550,
      height: 'auto !important',
      left: 'calc(50% - 275px)',
      top: 'calc(50% - 90px) !important',

      '& .panel-close-container': {
        '& .panel-cancel-icon': {
          paddingTop: 24,
        },
      },
      '& .panel-header': {
        paddingLeft: 24,
        marginBottom: 0,
      },
      '& .panel-body': {
        padding: 24,
      },
      '& .audience-modal.manage-tag-alert.in .modal-dialog': {
        '& .modal-content .modal-footer': {
          border: 'none',
          paddingTop: 24,
        },
      },
    },
  },
  '.modal-backdrop.in': {
    zIndex: 'auto',
    backgroundColor: palette.white,
  },
});
